import { convertQuerySelectorAll } from '../../../../src/js/components/helpers';

convertQuerySelectorAll('.large-card-slider', (elements) => {
	elements.forEach((element) => {
		const swiperElement = element as HTMLElement & {
			swiper?: InstanceType<typeof window.Swiper>;
		};

		// Destroy existing Swiper instance if it exists.
		if (swiperElement.swiper) {
			swiperElement.swiper.destroy(true, true);
		}

		new window.Swiper(swiperElement, {
			slidesPerView: 1,
			spaceBetween: 15,
			loop: true,
			pagination: {
				el: '.large-card-slider__dots',
				clickable: true,
			},
			navigation: {
				nextEl: '.large-card-slider__next',
				prevEl: '.large-card-slider__prev',
			},
		});
	});
});
